import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import Select from "react-select";

import useMessage from "hooks/useMessage";
import ToolTip from "components/ToolTip/ToolTip";
import { DEFAULT_PAGINATION_VALUES, StringHelper, DateHelper } from "utils";
import { GridView, SvgComponent } from "components";
import IconButton from "components/IconButton/IconButton";
import useExceptionHandler from "hooks/useExceptionHandler";
import ListHeader from "components/PantallaList/Header/ListHeader";
import { ComprobanteElectronicoManager as manager } from "managers";
import usePaginationValuesWhere from "hooks/usePaginationValuesWhere";
import Exportar from "components/Exportar/Exportar";
import { ComprobanteElectronico } from "models/ECF/ComprobanteElectronico";
import ModalContainer from "components/ModalContainer/ModalContainer";
import { Simplebar } from "components";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import { InputSidebarContainer } from "components";
import { Form } from "react-bootstrap";
import { DateTimePicker } from "components/DateTimePicker/DateTimePicker";
import uuid from "react-uuid";

export default function ComprobantesRecibidosList({
  showLoading,
  hideLoading,
}) {
  const [where, setWhere] = useState({});
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION_VALUES);
  const [list, setList] = useState([]);
  const [showExportar, setShowExportar] = useState(false);
  const [showCanvas, setShowCanvas] = useState(false);
  const [currentComprobante, setCurrentComprobantes] = useState({})
  const [dateFilterkey, setDateFilterKey] = useState(uuid());
  const [fechaCreacionFilterkey, setFechaCreacionFilterKey] = useState(uuid());
  const history = useHistory();
  const { cerrarAlertas } = useMessage();
  const { handleException } = useExceptionHandler();
  const { setPaginationValuesWhere } = usePaginationValuesWhere();

  const ESTATUS_LIST = [
    { value: "", label: "Todos" },
    { value: "N", label: "Nuevos" },
    { value: "A", label: "Aprobados" },
  ];

  useEffect(() => {
    buscar();
    return () => {
      cerrarAlertas();
      hideLoading();
    };
  }, [where]);

  function buscar() {
    const whereWithPaginationValues = {
      ...where,
      ...pagination,
      FechaInicio: where.RangoFechas?.fechaInicio,
      FechaFin: where.RangoFechas?.fechaFin,
      FechaInicioCreacion: where.RangoFechasCreacion?.fechaInicio,
      FechaFinCreacion: where.RangoFechasCreacion?.fechaFin,
    };

    manager
      .listado(whereWithPaginationValues)
      .then((res) => {
        setPaginationValuesWhere(res.Headers, pagination, setPagination);
        try {
          for (let comprobante of res.Data) {
            comprobante["FechaEmision"] = DateHelper.formatStringDate(
              comprobante["FechaEmision"]
            );
            comprobante["FechaCreacion"] = DateHelper.formatStringDate(
              comprobante["FechaCreacion"]
            );
            comprobante["FechaVencimientoSecuencia"] = DateHelper.formatStringDate(
              comprobante["FechaVencimientoSecuencia"]
            );
            comprobante["RNCEmisor"] = StringHelper.formatRNC(
              comprobante["RNCEmisor"]
            );
            comprobante["Monto"] = StringHelper.formatCurrency(
              comprobante["Monto"]
            );
            comprobante["MontoTotal"] = StringHelper.formatCurrency(
              comprobante["MontoTotal"]
            );
            comprobante["TotalITBISRetenido"] = StringHelper.formatCurrency(
              comprobante["TotalITBISRetenido"]
            );
            comprobante["TotalISRRetenido"] = StringHelper.formatCurrency(
              comprobante["TotalISRRetenido"]
            );
            comprobante["MontoGravado"] = StringHelper.formatCurrency(
              comprobante["MontoGravado"]
            );
            comprobante["MontoExento"] = StringHelper.formatCurrency(
              comprobante["MontoExento"]
            );
            comprobante["TotalITBIS"] = StringHelper.formatCurrency(
              comprobante["TotalITBIS"]
            );
            for (let detalle of comprobante.Detalles) {
              detalle["MontoItem"] = StringHelper.formatCurrency(
                detalle["MontoItem"]
              );
              detalle["PrecioUnitarioItem"] = StringHelper.formatCurrency(
                detalle["PrecioUnitarioItem"]
              );
              detalle["PrecioOtraMoneda"] = StringHelper.formatNumber(
                detalle["PrecioOtraMoneda"]
              );
              detalle["MontoOtraMoneda"] = StringHelper.formatNumber(
                detalle["MontoOtraMoneda"]
              );
              detalle["MontoITBISRetenido"] = StringHelper.formatCurrency(
                detalle["MontoITBISRetenido"]
              );
              detalle["MontoISRRetenido"] = StringHelper.formatCurrency(
                detalle["MontoISRRetenido"]
              );
            }
          }
        } catch (err) { }
        setList(res.Data);
      })
      .catch((err) => handleException(err))
      .finally(() => hideLoading());
  }

  const onPageIndexChanging = (pageNumber) => {
    setPagination((prevstate) => {
      return { ...prevstate, IndiceDePagina: pageNumber - 1 };
    });
    setWhere({ ...where });
  };

  const handleClick = (params) => {
    const { Id } = params;
    history.push(`/AprobacionComercialEdit?ComprobanteRecibidoId=${Id}`);
    const comprobanteRecibido = list.find((c) => c.Id == Id);
    if (comprobanteRecibido !== undefined) {
      setCurrentComprobantes(comprobanteRecibido);
      setShowCanvas(true);
    }

  };
  const handleClickDetalles = (params) => {
    const { Id } = params;
    const comprobanteRecibido = list.find((c) => c.Id == Id);
    if (comprobanteRecibido !== undefined) {
      setCurrentComprobantes(comprobanteRecibido);
      setShowCanvas(true);
    }

  };

  const openExportar = () => {
    setShowExportar(true);
  };
  const openExportarDetalles = () => {
    setShowExportarDetalles(true);
  };

  const onReset = () => {
    setDateFilterKey(uuid());
    setFechaCreacionFilterKey(uuid());
  };

const whereParaExportar = { ...where };

if (whereParaExportar.RangoFechasCreacion) {
  whereParaExportar.FechaInicioCreacion = whereParaExportar.RangoFechasCreacion.fechaInicio;
  whereParaExportar.FechaFinCreacion = whereParaExportar.RangoFechasCreacion.fechaFin;
  delete whereParaExportar.RangoFechasCreacion;
}

  return (
    <>
      <ViewComprobanteRecibido
        setShowCanvas={setShowCanvas}
        showCanvas={showCanvas}
        comprobanteRecibido={currentComprobante}
      />

      <Exportar
        PROPIEDADES_EXPORTAR={ComprobanteElectronico.PROPIEDADES_EXPORTAR}
        showExportar={showExportar}
        setShowExportar={setShowExportar}
        showLoading={showLoading}
        hideLoading={hideLoading}
        where={whereParaExportar}
        exportarCallBack={manager.exportar}
      ></Exportar>

      <ListHeader titulo="e-NCF Recibidos" exportar={openExportar} />
      <GridView
        pagination={pagination}
        setPagination={setPagination}
        allowPaging={pagination.EsPaginable}
        pageSize={pagination.CantidadPorPagina}
        pageIndex={pagination.IndiceDePagina}
        lastPageNumber={pagination.PaginasTotal}
        dataSource={list}
        onPageIndexChanging={onPageIndexChanging}
        where={where}
        setWhere={setWhere}
        height="83vh"
        onReset={onReset}
      >
        <GridView.Column
          width="120px"
          showClearFilter={true}
          bodyRenderer={(row) => {
            return (
              <>
                <div className="float-right">
                  <IconButton
                    onClick={() =>
                      handleClickDetalles({
                        Id: row.Id,
                      })
                    }
                  >
                    <ToolTip message="Ver Detalles">
                      <div>
                        <SvgComponent
                          iconName="view"
                          height="25px"
                          width="25px"
                        />
                      </div>
                    </ToolTip>
                  </IconButton>
                </div>

                <div className="float-right">
                  <IconButton
                    onClick={() =>
                      handleClick({
                        Id: row.Id,
                      })
                    }
                  >
                    <ToolTip message="Generar Aprobación Comercial">
                      <div>
                        <SvgComponent
                          iconName="attach-file"
                          height="25px"
                          width="25px"
                        />
                      </div>
                    </ToolTip>
                  </IconButton>
                </div>
              </>
            );
          }}
        />
        <GridView.Column
          headerText="Id"
          dataField="IdSec"
          sortExpression="IdSec"
          width="75px"
        />
        <GridView.Column
          headerText="Contribuyente"
          dataField="NombreComercial"
          sortExpression="NombreComercial"
        />
        <GridView.Column
          headerText="RNC"
          dataField="RNCEmisor"
          sortExpression="RNCEmisor"
        />
        <GridView.Column
          headerText="Tipo"
          dataField="TipoeCF"
          sortExpression="TipoeCF"
        />
        <GridView.Column
          headerText="E-NCF"
          dataField="NCF"
          sortExpression="NCF"
        />
        <GridView.Column
          date
          headerText="Fecha Emisión"
          dataField="FechaEmision"
          sortExpression="FechaEmision"
          width="250px"
          hideFilters
          filterRenderer={(onInputChange) => {
            return (
              <DateTimePicker
                key={dateFilterkey}
                soloFecha
                esRangoFechas
                esGrid
                usarLabel={false}
                fechaInicioOriginal={where?.RangoFechas?.fechaInicio || ""}
                fechaFinOriginal={where?.RangoFechas?.fechaFin || ""}
                onChange={(e) =>
                  onInputChange({
                    target: { name: "RangoFechas", value: e },
                  })
                }
              />
            );
          }}
        />
        <GridView.Column
          headerText="Monto Gravado"
          dataField="MontoGravado"
          sortExpression="MontoGravado"
          width="150px"
          isDisabled
        />
        <GridView.Column
          headerText="Monto Exento"
          dataField="MontoExento"
          sortExpression="MontoExento"
          width="150px"
          isDisabled
        />
        <GridView.Column
          headerText="Total ITBIS"
          dataField="TotalITBIS"
          sortExpression="TotalITBIS"
          width="150px"
          isDisabled
        />
        <GridView.Column
          headerText="Monto"
          dataField="Monto"
          sortExpression="Monto"
          isDisabled
        />
        <GridView.Column
          headerText="Estatus"
          dataField="EstatusDesc"
          sortExpression="Estatus"
          width="150px"
          filterRenderer={() => {
            return (
              <Select
                className="react-select primary"
                options={ESTATUS_LIST}
                value={ESTATUS_LIST.filter(function (option) {
                  return (
                    option.value ===
                    (where.Estatus ? where.Estatus : ESTATUS_LIST[0].value)
                  );
                })}
                name="Estatus"
                onChange={(e) =>
                  setWhere({
                    ...where,
                    Estatus: e.value,
                  })
                }
              />
            );
          }}
        />
        <GridView.Column
          date
          headerText="Fecha Creación"
          dataField="FechaCreacion"
          sortExpression="FechaCreacion"
          width="250px"
          filterRenderer={(onInputChange) => {
            return (
              <DateTimePicker
                key={fechaCreacionFilterkey}
                soloFecha
                esRangoFechas
                esGrid
                usarLabel={false}
                fechaInicioOriginal={
                  where?.RangoFechasCreacion?.fechaInicio || ""
                }
                fechaFinOriginal={where?.RangoFechasCreacion?.fechaFin || ""}
                onChange={(e) =>
                  onInputChange({
                    target: { name: "RangoFechasCreacion", value: e },
                  })
                }
              />
            );
          }}
        />
      </GridView>
    </>
  );
}
function ViewComprobanteRecibido({
  showCanvas,
  setShowCanvas,
  comprobanteRecibido,
}){
  const [showModal, setShowModal] = useState(false);

  return (
    <Simplebar
      backdrop={true}
      size="xxxl"
      placement={"end"}
      portal={false}
      visible={showCanvas}
      setShow={(e) => {
        setShowCanvas(e);
      }}
      useLoading={false}
      title="Comprobante Electronico Recibido"
      btnRight={{
        show: false,
        label: "Grabar",
        func: () => {},
      }}
      btnLeft={{
        show: false,
        label: "Cerrar",
      }}
    >
      {showModal}
      <EditSection title="Comprobante Recibido">
        <SectionRow triple={true}>
          <div className="d-flex">
            <InputSidebarContainer label="Id">
              <Form.Control
                value={comprobanteRecibido.Id}
                disabled={true}
                style={{width: '125px'}}
              />
            </InputSidebarContainer>
          </div>
          <div className="d-flex">
            <InputSidebarContainer label="Fecha Vencimiento Secuencia">
              <Form.Control
                value={comprobanteRecibido.FechaVencimientoSecuencia}
                disabled={true}
                style={{width: '200px'}}
              />
            </InputSidebarContainer>
          </div>
          <div className="d-flex">
            <InputSidebarContainer label="Tipo Pago">
              <Form.Control
                value={comprobanteRecibido.TipoPago}
                disabled={true}
                style={{width: '125px'}}
              />
            </InputSidebarContainer>
          </div>
        </SectionRow>
        <SectionRow triple={true}>
          <div className="d-flex">
            <InputSidebarContainer label="Tipo Ingreso">
              <Form.Control
                value={comprobanteRecibido.TipoIngresos}
                disabled={true}
                style={{width: '125px'}}
              />
            </InputSidebarContainer>
          </div>
          <div className="d-flex">
            <InputSidebarContainer label="Razon Social Comprador">
              <Form.Control
                value={comprobanteRecibido.RazonSocialComprador}
                disabled={true}
                style={{width: '250px'}}
              />
            </InputSidebarContainer>
          </div>
          <div className="d-flex">
            <InputSidebarContainer label="Contacto Comprador">
              <Form.Control
                value={comprobanteRecibido.ContactoComprador}
                disabled={true}
                style={{width: '250px'}}
              />
            </InputSidebarContainer>
          </div>
        </SectionRow>
        <SectionRow triple={true}>
          <div className="d-flex">
            <InputSidebarContainer label="Indicador Nota Credito">
              <Form.Control
                value={comprobanteRecibido.IndicadorNotaCredito}
                disabled={true}
                style={{width: '125px'}}
              />
            </InputSidebarContainer>
          </div>
          <div className="d-flex">
            <InputSidebarContainer label="Indicador Envio Diferido">
              <Form.Control
                value={comprobanteRecibido.IndicadorEnvioDiferido}
                disabled={true}
                style={{width: '125px'}}
              />
            </InputSidebarContainer>
          </div>
          <div className="d-flex">
            <InputSidebarContainer label="Indicador Monto Gravado">
              <Form.Control
                value={comprobanteRecibido.IndicadorMontoGravado}
                disabled={true}
                style={{width: '125px'}}
              />
            </InputSidebarContainer>
          </div>
        </SectionRow>
        <SectionRow triple={true}>
          <div className="d-flex">
            <InputSidebarContainer label="Total ITBIS Retenido">
              <Form.Control
                value={comprobanteRecibido.TotalITBISRetenido}
                disabled={true}
                style={{width: '200px'}}
              />
            </InputSidebarContainer>
          </div>
          <div className="d-flex">
            <InputSidebarContainer label="Total ISR Retenido">
              <Form.Control
                value={comprobanteRecibido.TotalISRRetenido}
                disabled={true}
                style={{width: '200px'}}
              />
            </InputSidebarContainer>
          </div>
          <div className="d-flex">
            <InputSidebarContainer label="Monto Total">
              <Form.Control
                value={comprobanteRecibido.MontoTotal}
                disabled={true}MontoTotal
                style={{width: '200px'}}
              />
            </InputSidebarContainer>
          </div>
        </SectionRow>
      </EditSection>
      <div></div>
      <EditSection title="Comprobante Recibido Detalles">
        <GridView
          dataSource={comprobanteRecibido.Detalles}
          allowPaging={false}
          hideFilters={true}
          height="35vh"
        >
          <GridView.Column
            headerText="Id"
            dataField="IdSec"
            sortExpression="IdSec"
            width="auto"
          />
          <GridView.Column
            headerText="Numero Linea"
            dataField="NumeroLinea"
            sortExpression="NumeroLinea"
            width="auto"
          />
          <GridView.Column
            headerText="Nombre Item"
            dataField="NombreItem"
            sortExpression="NombreItem"
            width="auto"
          />
          <GridView.Column
            headerText="Indicador Bien o Servicio"
            dataField="IndicadorBienOServicio"
            sortExpression="IndicadorBienOServicio"
            width="auto"
          />
          <GridView.Column
            headerText="Indicador Facturacion"
            dataField="IndicadorFacturacion"
            sortExpression="IndicadorFacturacion"
            width="auto"
          />
          <GridView.Column
            headerText="Cantidad Items"
            dataField="CantidadItems"
            sortExpression="CantidadItems"
            width="auto"
          />
          <GridView.Column
            headerText="Precio Unitario"
            dataField="PrecioUnitarioItem"
            sortExpression="PrecioUnitarioItem"
            width="auto"
          />
          <GridView.Column
            headerText="Precio Otra Moneda"
            dataField="PrecioOtraMoneda"
            sortExpression="PrecioOtraMoneda"
            width="auto"
          />
          <GridView.Column
            headerText="Descuento Otra Moneda"
            dataField="DescuentoOtraMoneda"
            sortExpression="DescuentoOtraMoneda"
            width="auto"
          />
          <GridView.Column
            headerText="Recargo Otra Moneda"
            dataField="RecargoOtraMoneda"
            sortExpression="RecargoOtraMoneda"
            width="auto"
          />
          <GridView.Column
            headerText="Monto Otra Moneda"
            dataField="MontoOtraMoneda"
            sortExpression="MontoOtraMoneda"
            width="auto"
          />
          <GridView.Column
            headerText="Monto Itbis Retenido"
            dataField="MontoITBISRetenido"
            sortExpression="MontoITBISRetenido"
            width="auto"
          />
          <GridView.Column
            headerText="Monto Isr Retenido"
            dataField="MontoISRRetenido"
            sortExpression="MontoISRRetenido"
            width="auto"
          />
          <GridView.Column
            headerText="Descuento Monto"
            dataField="DescuentoMonto"
            sortExpression="DescuentoMonto"
            width="auto"
          />
          <GridView.Column
            headerText="Recargo Monto"
            dataField="RecargoMonto"
            sortExpression="RecargoMonto"
            width="auto"
          />
          <GridView.Column
            headerText="Monto"
            dataField="MontoItem"
            sortExpression="MontoItem"
            width="auto"
          />
        </GridView>
      </EditSection>
      <div></div>
      <EditSection title="Comprobante Recibido Forma de Pagos">
        <GridView
          dataSource={comprobanteRecibido.FormaPagos}
          allowPaging={false}
          hideFilters={true}
          height="25vh"
        >
          <GridView.Column
            headerText="Id"
            dataField="IdSec"
            sortExpression="IdSec"
            width="auto"
          />
          <GridView.Column
            headerText="Forma de Pago"
            dataField="FormaPago"
            sortExpression="FormaPago"
            width="auto"
          />
          <GridView.Column
            headerText="Monto Pago"
            dataField="MontoPago"
            sortExpression="MontoPago"
            width="auto"
          />
        </GridView>
      </EditSection>
      <div></div>
      <EditSection title="Comprobante Recibido Descuentos o Recargos">
        <GridView
          dataSource={comprobanteRecibido.DescuentoRecargo}
          allowPaging={false}
          hideFilters={true}
          height="35vh"
        >
          <GridView.Column
            headerText="Id"
            dataField="IdSec"
            sortExpression="IdSec"
            width="auto"
          />
          <GridView.Column
            headerText="Numero Linea"
            dataField="NumeroLinea"
            sortExpression="NumeroLinea"
            width="auto"
          />
          <GridView.Column
            headerText="Descripcion"
            dataField="DescripcionDescuentooRecargo"
            sortExpression="DescripcionDescuentooRecargo"
            width="auto"
          />
          <GridView.Column
            headerText="Indicador Fact. Desc. o Recargo"
            dataField="IndicadorFacturacionDescuentooRecargo"
            sortExpression="IndicadorFacturacionDescuentooRecargo"
            width="auto"
          />
          <GridView.Column
            headerText="Indicador Norma 1007"
            dataField="IndicadorNorma1007"
            sortExpression="IndicadorNorma1007"
            width="auto"
          />
          <GridView.Column
            headerText="Tipo Ajuste"
            dataField="TipoAjuste"
            sortExpression="TipoAjuste"
            width="auto"
          />
          <GridView.Column
            headerText="Tipo Valor"
            dataField="TipoValor"
            sortExpression="TipoValor"
            width="auto"
          />
          <GridView.Column
            headerText="Valor Descuento o Recargo"
            dataField="ValorDescuentooRecargo"
            sortExpression="ValorDescuentooRecargo"
            width="auto"
          />
          <GridView.Column
            headerText="Monto Desc. o Reca. Otra Moneda"
            dataField="MontoDescuentooRecargoOtraMoneda"
            sortExpression="MontoDescuentooRecargoOtraMoneda"
            width="auto"
          />
          <GridView.Column
            headerText="Monto Descuento o Recargo"
            dataField="MontoDescuentooRecargo"
            sortExpression="MontoDescuentooRecargo"
            width="auto"
          />
        </GridView>
      </EditSection>
      <div></div>
      <EditSection title="Comprobante Recibido Impuesto Adicionales">
        <GridView
          dataSource={comprobanteRecibido.ImpuestoAdicionales}
          allowPaging={false}
          hideFilters={true}
          height="35vh"
        >
          <GridView.Column
            headerText="Id"
            dataField="IdSec"
            sortExpression="IdSec"
            width="auto"
          />
          <GridView.Column
            headerText="Tipo Impuesto"
            dataField="TipoImpuesto"
            sortExpression="TipoImpuesto"
            width="auto"
          />
          <GridView.Column
            headerText="Tasa Impuesto Adicional"
            dataField="TasaImpuestoAdicional"
            sortExpression="TasaImpuestoAdicional"
            width="auto"
          />
          <GridView.Column
            headerText="Otros Impuestos Adicionales"
            dataField="OtrosImpuestosAdicionales"
            sortExpression="OtrosImpuestosAdicionales"
            width="auto"
          />
          <GridView.Column
            headerText="Monto Impuesto Selectivo Advalorem"
            dataField="MontoImpuestoSelectivoConsumoAdvalorem"
            sortExpression="MontoImpuestoSelectivoConsumoAdvalorem"
            width="auto"
          />
          <GridView.Column
            headerText="Monto Impuesto Selectivo Especifico"
            dataField="MontoImpuestoSelectivoConsumoEspecifico"
            sortExpression="MontoImpuestoSelectivoConsumoEspecifico"
            width="auto"
          />
        </GridView>
      </EditSection>
      <div></div>
      <EditSection title="Comprobante Recibido Impuesto Otra Moneda">
        <GridView
          dataSource={comprobanteRecibido.ImpuestoOtraMonedas}
          allowPaging={false}
          hideFilters={true}
          height="35vh"
        >
          <GridView.Column
            headerText="Id"
            dataField="IdSec"
            sortExpression="IdSec"
            width="auto"
          />
          <GridView.Column
            headerText="Tipo Impuesto Otra Moneda"
            dataField="TipoImpuestoOtraMoneda"
            sortExpression="TipoImpuestoOtraMoneda"
            width="auto"
          />
          <GridView.Column
            headerText="Tasa Impuesto Adicional Otra Moneda"
            dataField="TasaImpuestoAdicionalOtraMoneda"
            sortExpression="TasaImpuestoAdicionalOtraMoneda"
            width="auto"
          />
          <GridView.Column
            headerText="Otros Impuestos Adicionales Otra Moneda"
            dataField="OtrosImpuestosAdicionalesOtraMoneda"
            sortExpression="OtrosImpuestosAdicionalesOtraMoneda"
            width="auto"
          />
          <GridView.Column
            headerText="Monto Impuesto Selectivo Advalorem Otra Moneda"
            dataField="MontoImpuestoSelectivoConsumoAdvaloremOtraMoneda"
            sortExpression="MontoImpuestoSelectivoConsumoAdvaloremOtraMoneda"
            width="auto"
          />
          <GridView.Column
            headerText="Monto Impuesto Selectivo Especifico Otra Moneda"
            dataField="MontoImpuestoSelectivoConsumoEspecificoOtraMoneda"
            sortExpression="MontoImpuestoSelectivoConsumoEspecificoOtraMoneda"
            width="auto"
          />
        </GridView>
      </EditSection>
      <div></div>
      <EditSection title="Comprobante Recibido SubTotales Informativos">
        <GridView
          dataSource={comprobanteRecibido.SubTotales}
          allowPaging={false}
          hideFilters={true}
          height="35vh"
        >
          <GridView.Column
            headerText="Id"
            dataField="IdSec"
            sortExpression="IdSec"
            width="auto"
          />
          <GridView.Column
            headerText="Lineas"
            dataField="Lineas"
            sortExpression="Lineas"
            width="auto"
          />
          <GridView.Column
            headerText="Numero SubTotal"
            dataField="NumeroSubTotal"
            sortExpression="NumeroSubTotal"
            width="auto"
          />
          <GridView.Column
            headerText="Orden"
            dataField="Orden"
            sortExpression="Orden"
            width="auto"
          />
          <GridView.Column
            headerText="Descripcion"
            dataField="DescripcionSubtotal"
            sortExpression="DescripcionSubtotal"
            width="auto"
          />
          <GridView.Column
            headerText="SubTotal ITBIS"
            dataField="SubTotaITBIS"
            sortExpression="SubTotaITBIS"
            width="auto"
          />
          <GridView.Column
            headerText="SubTotal ITBIS Exento"
            dataField="SubTotalExento"
            sortExpression="SubTotalExento"
            width="auto"
          />
          <GridView.Column
            headerText="SubTotal Impuesto Adicional"
            dataField="SubTotalImpuestoAdicional"
            sortExpression="SubTotalImpuestoAdicional"
            width="auto"
          />
          <GridView.Column
            headerText="SubTotal Monto Gravado Total"
            dataField="SubTotalMontoGravadoTotal"
            sortExpression="SubTotalMontoGravadoTotal"
            width="auto"
          />
          <GridView.Column
            headerText="Monto SubTotal"
            dataField="MontoSubTotal"
            sortExpression="MontoSubTotal"
            width="auto"
          />
        </GridView>
      </EditSection>

    </Simplebar>
  )
}
